import { datadogRum } from '@datadog/browser-rum';

/**
 * Analytics utility for tracking user actions in Datadog RUM.
 * Replaces legacy EventService that stored events in Hasura.
 */

/**
 * Core tracking function with error handling and initialization check
 */
const track = (actionName: string, context: Record<string, unknown>): void => {
  try {
    if (!datadogRum.getInitConfiguration()) return;
    datadogRum.addAction(actionName, context);
  } catch (error) {
    console.warn(`Failed to track ${actionName}:`, error);
  }
};

export const trackPageView = (page: string): void => {
  track('page_view', { page });
};

export const trackLabelPrint = (params: { success: boolean; shipmentId?: string; error?: unknown }): void => {
  track('label_print', params);
};

export const trackWorkflowSave = (params: {
  actionType: string;
  assetType: string;
  assetName?: string;
  metadata?: unknown;
}): void => {
  track('workflow_save', params);
};
